/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Buttons from 'components/Buttons';
import Text from 'components/Text';
import GroupsContentTitle from 'groups/components/GroupsContentTitle';

import './styles/GroupsContentHeader.scss';

type Props = {
  actions?: ?React$Element<*>,
  className?: string,
  title: string,
  titleCount?: ?number,
};

export default function GroupsContentHeader({ actions, className, title, titleCount }: Props) {
  return (
    <header className={cx('GroupsContentHeader', className)}>
      <GroupsContentTitle>
        {title}
        {titleCount && <Text color="thunder"> ({titleCount})</Text>}
      </GroupsContentTitle>
      {actions && <Buttons reset="none">{actions}</Buttons>}
    </header>
  );
}
